import { useEffect } from 'react';

const ShareRedirect = () => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const sponsorId = searchParams.get('sponsorId') || '';

    const host = 'taskplanet.org'; // Must match your manifest's `<data android:host="taskplanet.org" />`

    const intentUrl = `intent://${host}/share?sponsorId=${sponsorId}#Intent;scheme=https;package=com.taskplanet;end`;
    const fallbackUrl = `https://play.google.com/store/apps/details?id=com.taskplanet&referrer=sponsorId=${sponsorId}`;

    // Try opening the app
    window.location.href = intentUrl;

    // Fallback to Play Store if app isn't installed
    const timeout = setTimeout(() => {
      window.location.href = fallbackUrl;
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return null; // No UI
};

export default ShareRedirect;
